var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 38,
    viewBox: "0 0 184 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.84962 33.6011L0 8.12084C0 0.193648 3.89975 -0.466951 5.84962 0.193648H178.795C184.492 0.64663 184.39 5.66718 183.627 8.12084L177.523 33.6011C177.727 36.9985 173.708 37.8478 171.674 37.8478H12.4622C8.79987 38.7538 6.52784 35.3942 5.84962 33.6011Z",
    fill: "url(#paint0_linear_458_10)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_458_10",
    x1: 77,
    y1: 1.67561e-7,
    x2: 148,
    y2: 38,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#454C9C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9F5BF0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector3);
export default __webpack_public_path__ + "static/media/Vector-3.fb896544c3604d73f24eaa9eb16d8e44.svg";
export { ForwardRef as ReactComponent };